import { render } from "./ItemCommonFields.vue?vue&type=template&id=037f2fba&ts=true"
import script from "./ItemCommonFields.vue?vue&type=script&lang=ts"
export * from "./ItemCommonFields.vue?vue&type=script&lang=ts"

import "./ItemCommonFields.vue?vue&type=style&index=0&id=037f2fba&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__